/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';

const style: ouiStyle.InStyleWithMediaQueries = {
  display: ouiStyle.Constants.DisplayProp.flex,
  flexDirection: [ouiStyle.Constants.InFlexDirectionProp.col, undefined, undefined, ouiStyle.Constants.InFlexDirectionProp.row, undefined, undefined],
  flexReverse: [true, undefined, undefined, false, undefined, undefined],
  alignItems: [ouiStyle.Constants.AlignItemsProp.center, undefined, undefined, ouiStyle.Constants.AlignItemsProp.normal, undefined, undefined],
  container: ouiStyle.Constants.Container.xl,
  paddingHorizontal: [0, undefined, undefined, 'simple', undefined, undefined],
  paddingTop: 'double',
};

const css = ouiStyle.mediaQuery(ouiStyle.makeCss(style));

export const ArticlePageWrapper = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  return (
    <section
      css={css}
    >
      {children}
    </section>
  );
};
